import service from "@/store/services/cash-register-reading-invoice-items-service";

export const state = () => ({
  list: {},
  cashRegisterReadingInvoiceItem: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cashRegisterReadingInvoiceItem) => {
    state.cashRegisterReadingInvoiceItem = cashRegisterReadingInvoiceItem;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((cashRegisterReadingInvoiceItem) => {
      commit("SET_RESOURCE", cashRegisterReadingInvoiceItem);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((cashRegisterReadingInvoiceItem) => {
      commit("SET_RESOURCE", cashRegisterReadingInvoiceItem);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((cashRegisterReadingInvoiceItem) => {
      commit("SET_RESOURCE", cashRegisterReadingInvoiceItem);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  cashRegisterReadingInvoiceItem: (state) => state.cashRegisterReadingInvoiceItem,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((cashRegisterReadingInvoiceItem) => ({
      id: cashRegisterReadingInvoiceItem.id,
      name: ``,
    }));
  },
};

const cashRegisterReadingInvoiceItems = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cashRegisterReadingInvoiceItems;
